import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Reaction.css";

const Reaction = () => {

  const navigate = useNavigate();

  const initialForm = () => ({
    name: "",
    email: localStorage.getItem("rg_email") || "",
    phone: localStorage.getItem("rg_phone") || "",
    age: "",
  });

  const [formData] = useState(initialForm);

  const [circleColor, setCircleColor] = useState("red");
  const [reactionTime, setReactionTime] = useState(0);
  const [startTime, setStartTime] = useState(null);

  const [clickCount, setClickCount] = useState(0);
  const [wrongClickCount, setWrongClickCount] = useState(0);

  const [results, setResults] = useState([]);
  const [countdown, setCountdown] = useState(null);
  const [greenClicked, setGreenClicked] = useState(false);

  const [page, setPage] = useState("game");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* START GAME */

  const startGame = () => {

    setCircleColor("red");
    setCountdown(null);
    setGreenClicked(false);

    setTimeout(() => {

      setCircleColor("green");
      setStartTime(performance.now());

    }, Math.random() * 2000 + 1000);

  };

  useEffect(() => {
    startGame();
  }, []);

  /* CLICK */

  const handleCircleClick = () => {

    if (circleColor === "green" && startTime && !greenClicked) {

      setGreenClicked(true);

      const endTime = performance.now();
      const timeTaken = ((endTime - startTime) / 1000).toFixed(3);

      setReactionTime(timeTaken);
      setClickCount(prev => prev + 1);
      setResults(prev => [...prev, timeTaken]);

      setCountdown(5);

    } else {

      setWrongClickCount(prev => prev + 1);

    }

  };

  /* SAVE DATA (NEW API) */

  const saveGameData = useCallback(async () => {

    try {

     axios.post("/api/reaction-save", {
        email: formData.email,
        phone: formData.phone,
        results,
        wrongClicks: wrongClickCount
});
    } catch (error) {

      console.error("Save error:", error);

    }

  }, [formData, results, wrongClickCount]);

  /* COUNTDOWN */

  useEffect(() => {

    if (countdown !== null && countdown > 0) {

      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);

    } else if (countdown === 0) {

      setCircleColor("red");

      if (clickCount < 5) {

        startGame();

      } else {

        setPage("result");
        saveGameData();

      }

    }

  }, [countdown, clickCount, saveGameData]);

  /* EXIT */

  const handleExit = async () => {

    await saveGameData();
    navigate("/");
  };

  return (

    <div className="containerr">

      {/* GAME */}

      {page === "game" && (

        <div className="game-containerr">

          <div
            className={`circler ${circleColor}`}
            onClick={handleCircleClick}
          ></div>

          <p className="reaction-timer">
            Reaction Time: {(reactionTime * 1000).toFixed(0)} ms
          </p>

          {countdown !== null && (
            <p className="countdownr">
              Next Round: {countdown}
            </p>
          )}

          <p className="wrong-clickr">
            Wrong Clicks: {wrongClickCount}
          </p>

        </div>

      )}

      {/* RESULT */}

      {page === "result" && (

        <div className="results-box">

          <h2>Your Attempts</h2>

          <ul>
            {results.map((time, index) => (
              <li key={index}>
                Attempt {index + 1}: {(time * 1000).toFixed(0)} ms
              </li>
            ))}
          </ul>

          <p>Total Wrong Clicks: {wrongClickCount}</p>

          <button
            onClick={handleExit}
            className="exit-buttonr"
          >
            Finish
          </button>

        </div>

      )}

    </div>

  );

};

export default Reaction;